module.exports = "/img/icon.8aebdbd9.png";